import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberToWords',
  standalone: true,
})
export class NumberToWordsPipe implements PipeTransform {
  transform(value: number, word: string): string {
    // Validate number - return '***' if invalid
    if (
      value === null ||
      value === undefined ||
      typeof value !== 'number' ||
      isNaN(value)
    ) {
      return '***';
    }

    // Validate word - use empty string if not valid
    let trimmedWord = '';
    if (word && typeof word === 'string') {
      trimmedWord = word.trim();
    }

    const numStr = value.toString();

    if (trimmedWord === '') {
      return numStr;
    }

    const pluralWord = value === 1 ? trimmedWord : this.pluralize(trimmedWord);
    return `${numStr} ${pluralWord}`;
  }

  private pluralize(word: string): string {
    // Handle common irregular plurals
    const irregulars: { [key: string]: string } = {
      child: 'children',
      person: 'people',
      man: 'men',
      woman: 'women',
      tooth: 'teeth',
      foot: 'feet',
      mouse: 'mice',
      goose: 'geese',
      quiz: 'quizzes',
    };

    const irregularPlural = irregulars[word.toLowerCase()];
    if (irregularPlural) {
      return irregularPlural;
    }

    // Handle words ending in 's', 'ss', 'sh', 'ch', 'x', 'z'
    if (/[sxz]$/.test(word) || /[sh]$/.test(word) || /ch$/.test(word)) {
      return word + 'es';
    }

    // Handle words ending in consonant + 'y'
    if (/[^aeiou]y$/.test(word)) {
      return word.slice(0, -1) + 'ies';
    }

    // Handle words ending in 'f' or 'fe'
    if (/f$/.test(word)) {
      return word.slice(0, -1) + 'ves';
    }
    if (/fe$/.test(word)) {
      return word.slice(0, -2) + 'ves';
    }

    // Handle words ending in consonant + 'o'
    if (/[^aeiou]o$/.test(word)) {
      return word + 'es';
    }

    // Default: just add 's'
    return word + 's';
  }
}
